package com.evoapps.evoshift.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class Notification(
    val id: String = "",
    val userId: String,
    val title: String,
    val message: String,
    val type: NotificationType,
    val createdAt: String,
    val isRead: Boolean = false,
    val data: Map<String, String> = emptyMap()
)

@Serializable
enum class NotificationType {
    ROSTER_PUBLISHED,
    SHIFT_ASSIGNED,
    SHIFT_SWAP_REQUEST,
    SHIFT_SWAP_APPROVED,
    SHIFT_SWAP_REJECTED,
    AVAILABILITY_REQUEST,
    SHIFT_CLAIM_PENDING,
    SHIFT_CLAIM_APPROVED,
    SHIFT_CLAIM_REJECTED,
    OPEN_SHIFTS_AVAILABLE,
    /** A person has not clocked in for their shift (functions/noShow.js, SH-73); managers only. */
    SHIFT_NO_SHOW,
    /** A closing checklist is not done after the shift ended (functions/checklists.js, SH-121). */
    CHECKLIST_OVERDUE,
    GENERAL
}
